export default "__VITE_ASSET__BIZXz7$7__"